/* eslint-disable prefer-destructuring */
import styled from "styled-components";
import * as CommonBasketButtonStyles from "../../../../../../../../common-deprecated/styles/v2/lexus/components/BasketButton";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getDirection } from "../../../../../../../../common-deprecated/themes/common";
import * as MonthlyPriceStyles from "../../price/styles/MonthlyPrice";
import * as ButtonStyles from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import * as CashPriceStyles from "../../price/styles/CashPrice";
import * as DisclaimerStyles from "../../../../../../../../common-deprecated/styles/lexus/Disclaimer";
import * as TypeStyle from "../../../../../../../../common-deprecated/styles/lexus/Type";

export const MobileBasket = CommonBasketButtonStyles.MobileBasket;

export const BasketTitle = CommonBasketButtonStyles.BasketTitle;

export const BasketTitleWrapper = CommonBasketButtonStyles.BasketTitleWrapper;

export const MobileBasketHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 0;
    color: ${theme.colors.azure};
`;

export const CloseMobileBasket = styled.button`
    position: relative;
    top: -${theme.space[1]}px;
    width: auto;
    margin-${getDirection("left")}: auto;
    margin-${getDirection("right")}: -8px;
    color: ${theme.colors.white};
    background: transparent;
    border: 0;
`;

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${theme.space[2]}px;
`;

export const Button = styled.button`
    display: flex;
    position: relative;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    padding: 0;
    background-color: transparent;
    border: 2px solid ${theme.colors.azure};
    border-radius: 50%;

    svg {
        color: ${theme.colors.azure};
    }
`;

export const ItemCount = styled.span`
    position: absolute;
    top: -10px;
    ${getDirection("right")}: -4px;
    width: 24px;
    padding: 1px 5px 2px;
    font-family: ${theme.fonts.bold};
    font-size: 1rem;
    line-height: 1.6rem;
    text-align: center;
    color: ${theme.colors.white};
    background-color: ${theme.colors.skyBlue};
    border-radius: 10px;
`;

export const Pricing = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${MonthlyPriceStyles.Text},
    ${CashPriceStyles.Text} {
        display: block;
        font-family: ${theme.fonts.regular};
        font-size: 1.4rem;
        letter-spacing: .1em;
        line-height: 1.5rem;
        color: ${theme.colors.azure};
    }
    ${CashPriceStyles.Text} {
        span:not(:nth-last-child(1)) {
            display: inline-block;
        }

        span:first-child:not(:nth-last-child(1)) {
            margin-left: ${theme.space[1]}px;
        }
    }
    ${DisclaimerStyles.default} {
        display: inline-block;
        position: relative;
        line-height: 1;
        color: ${theme.colors.azure};
        ${TypeStyle.Medium} {
			margin-bottom: 0;
            padding-${getDirection("left")}: 0;
            padding-${getDirection("right")}: 20px;
			font-size: 1.3rem;
        }
        ${ButtonStyles.Link} {
        flex-direction: row-reverse;
        align-items: center;
        color: ${theme.colors.azure};
        .icon::before {
            /* fix bad icon alignment */
            position: relative;
            top: 1px;
            color: ${theme.colors.azure};
        }
    }
    }
`;

export const FinanceTitle = styled.span`
    font-family: ${theme.fonts.regular};
    font-size: 1.2rem;
`;
